import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[equal-value][formControlName],[equal-value],[formControl],[equal-value][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EqualValueValidatorDirective, multi: true }]
})
export class EqualValueValidatorDirective implements Validator {
  @Input() valueToCompare: string = "";
  @Input() validationError: string = "El valor tiene que ser igual."

  constructor() { }

  validate(c: AbstractControl): { [key: string]: any } | null {
    const value: string = c.value;
    const response: { [key: string]: any } | null = value != this.valueToCompare ? { 'equal-value': true, "validationError": this.validationError } : null;
    return response;
  }
}
